import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { IconColor, IconComponent } from '@shared-lib/components/icon/icon.component';
import { MultiactionButtonComponent } from '@shared/components/multiaction-button/multiaction-button.component';
import { NavigationService } from '@shared/services/navigation.service';
import { MenuItem } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'cp-detail-header',
  imports: [ButtonDirective, IconComponent, MultiactionButtonComponent, OverlayPanelModule, NgClass],
  templateUrl: './detail-header.component.html',
  styleUrl: './detail-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailHeaderComponent {
  @Input({ required: true }) headline: string;
  @Input() isMenuVisible = false;
  @Input() isBackButtonVisible = true;
  @Input() isActionButtonVisible = false;
  @Input() menuItems: MenuItem[] = [];
  @Input() actionIcon: string;
  @Input() actionIconSize: string;
  @Input() buttonClass: string;
  @Input() titleSize: 'small' | 'medium' = 'medium';
  @Input() variant: 'light' | 'light-gold' | 'light-gray-turquoise' | 'remortgage-guide' | 'better-deal' = 'light';
  @Input() hasCustomBackAction = false;
  @Output() actionClicked = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  private readonly navigationService = inject(NavigationService);

  protected readonly IconColor = IconColor;

  backClicked(): void {
    if (this.hasCustomBackAction) return this.back.emit();
    this.navigationService.back();
  }

  emitActionClicked(): void {
    this.actionClicked.emit();
  }
}
